<template>
  
  <div class="chartAutonomia">
    <div class="chartItemTitulo">Autonomia Media</div>
        <div class="chartItemIcone" id="iconeAutonomiachart">
          <i class="fas fa-stopwatch"></i>
        </div>
        <div class="chartItemValor">1h 04 minutos </div>
  </div>

</template>

<script>

export default {
    name: 'ChartAutonomia'
}
</script>

<style>
.chartAutonomia {
  position: relative;
  width:100%;
  min-width: 200px;
  height: 100%;
  min-height: 300px;
}
#iconeAutonomiachart {
  color: red;
}
</style>